import React, { useState, useEffect } from "react";
import Logo from "../assets/images/logo.png";
import { Search, ShoppingCart, Menu } from "lucide-react";

const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" && window.innerWidth < 992
  );

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <nav
      className="navbar navbar-expand-lg fixed-top"
      style={{
        backgroundColor:
          scrolled || isMobile ? "rgba(139, 123, 168, 0.95)" : "transparent",
        transition: "background-color 0.3s ease",
        zIndex: 1000,
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Sticky Transparent Navbar */}
      <div className="container-fluid px-4">
        {/* Logo */}
        <a
          className="navbar-brand"
          href="/"
          style={{
            marginRight: scrolled ? "1.5rem" : "3rem",
            transition: "margin-right 300ms cubic-bezier(0.4,0,0.2,1)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={Logo}
            alt="Pups N Treats Logo"
            style={{
              height: isMobile ? "60px" : "90px",
              width: "auto",
              objectFit: "contain",
              transform: scrolled ? "scale(0.75)" : "scale(1)",
              transformOrigin: "left center",
              transition:
                "transform 320ms cubic-bezier(0.2, 0.8, 0.2, 1), height 320ms cubic-bezier(0.2,0.8,0.2,1)",
              willChange: "transform",
            }}
          />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          style={{
            border: "none",
            background: "transparent",
            transition: "transform 220ms ease, opacity 220ms ease",
            // transform: scrolled ? "translateY(2px)" : "translateY(0)",
            padding: "0.5rem",
            display: isMobile ? "flex" : "none",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Menu size={28} color="#fff" />
        </button>

        <div
          className="collapse navbar-collapse"
          id="navbarNav"
          style={{
            transition:
              "background-color 300ms cubic-bezier(0.4,0,0.2,1), box-shadow 300ms ease",
            borderRadius: "12px",
            padding: "0.25rem",
          }}
        >
          <ul
            className="navbar-nav mx-auto mb-2 mb-lg-0 align-items-center"
            style={{ gap: "1.5rem", transition: "gap 300ms ease" }}
          >
            <li className="nav-item">
              <a
                className="nav-link"
                href="/"
                style={{ color: "#fff", fontWeight: "500" }}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="/products"
                style={{ color: "#fff", fontWeight: "500" }}
              >
                Products
              </a>
            </li>
            {/* <li className="nav-item">
              <a
                className="nav-link"
                href="#"
                style={{ color: "#fff", fontWeight: "500" }}
              >
                Partnerships
              </a>
            </li> */}
            <li className="nav-item">
              <a
                className="nav-link"
                href="/faqs"
                style={{ color: "#fff", fontWeight: "500" }}
              >
                FAQs
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="/blogs"
                style={{ color: "#fff", fontWeight: "500" }}
              >
                Blogs
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="/contact-us"
                style={{ color: "#fff", fontWeight: "500" }}
              >
                Contact
              </a>
            </li>
            <li className="nav-item">
              <div style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  style={{
                    borderRadius: "25px",
                    paddingRight: "45px",
                    width: scrolled ? "140px" : "180px",
                    border: "none",
                    fontSize: "0.9rem",
                    transition:
                      "width 280ms cubic-bezier(0.4,0,0.2,1), box-shadow 200ms ease",
                  }}
                />
                <button
                  style={{
                    position: "absolute",
                    right: "5px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "#FF6B35",
                    border: "none",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "background 180ms ease, transform 180ms ease",
                  }}
                >
                  <Search size={16} color="#fff" />
                </button>
              </div>
            </li>
            <li className="nav-item">
              <button
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  transition: "transform 180ms ease, opacity 180ms ease",
                }}
              >
                <ShoppingCart size={24} color="#fff" />
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
